import * as React from 'react';

import styles from './OfferMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessage } from '../ChatMessage';

interface IOfferMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  offerMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
  replyQuote?: React.ReactNode;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const OfferMessageLayout = React.forwardRef<HTMLDivElement, IOfferMessageLayoutProps>(
  function OfferMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      offerMessage,
      messageMeta,
      actionButtons,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText} dataName="OfferMessageLayout">
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['offer-message__bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['offer-message__quote']}>{replyQuote}</div>
          {offerMessage}
          {actionButtons}
          <div className={styles['offer-message__meta']}>{messageMeta}</div>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
